import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Icon from 'components/AppIcon';

export default function LoginScreen() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!form?.email || !form?.password) {
      setError('Por favor completa todos los campos.');
      return;
    }
    setLoading(true);
    setError('');
    const { error: signInError } = await signIn(form?.email, form?.password);
    setLoading(false);
    if (signInError) {
      setError(signInError?.message || 'Error al iniciar sesión.');
    } else {
      navigate('/visit-form-registration-screen');
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex flex-col items-center mb-8">
          <img
            src="/assets/images/VLS-logo600x300-1-1773075783886.png"
            alt="VLS Adventure Park logo"
            style={{ maxWidth: '220px', width: '100%', height: 'auto' }}
            className="mb-3"
          />
          <p className="text-sm text-muted-foreground mt-1">Sistema de Gestión de Visitas</p>
        </div>

        {/* Card */}
        <div className="bg-card border border-border rounded-xl p-6" style={{ boxShadow: '0 4px 16px rgba(28,25,23,0.08)' }}>
          <h2 className="text-lg font-semibold text-foreground mb-5">Iniciar Sesión</h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-medium text-muted-foreground mb-1.5">Email</label>
              <input
                type="email"
                value={form?.email}
                onChange={(e) => setForm(prev => ({ ...prev, email: e?.target?.value }))}
                placeholder="tu@email.com"
                className="w-full px-3 py-3 text-base bg-background border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-ring text-foreground placeholder:text-muted-foreground"
                autoComplete="email"
                inputMode="email"
                autoCapitalize="off"
                disabled={loading}
              />
            </div>
            <div>
              <label className="block text-xs font-medium text-muted-foreground mb-1.5">Contraseña</label>
              <input
                type="password"
                value={form?.password}
                onChange={(e) => setForm(prev => ({ ...prev, password: e?.target?.value }))}
                placeholder="••••••••"
                className="w-full px-3 py-3 text-base bg-background border border-border rounded-md focus:outline-none focus:ring-2 focus:ring-ring text-foreground placeholder:text-muted-foreground"
                autoComplete="current-password"
                disabled={loading}
              />
            </div>

            {error && (
              <div className="flex items-center gap-2 p-3 rounded-md bg-red-50 border border-red-200">
                <Icon name="AlertCircle" size={14} color="#dc2626" />
                <p className="text-xs text-red-700">{error}</p>
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full py-3 rounded-md text-base font-semibold text-white transition-all disabled:opacity-60 active:scale-[0.98]"
              style={{ background: 'var(--color-primary)', minHeight: 48 }}
            >
              {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
